import { IconNames } from '@blueprintjs/icons';
import { Button } from '@strata/react-buttons';
import { Dialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import PropTypes from 'prop-types';

import { handleError } from 'services/Error';
import { useDeleteOnboardingStatusMutation } from 'store/api/userSupportApi';

const Title = 'Delete Fill Activity';

export const DeleteFillActivityDialog = ({
    isOpen,
    eventId = undefined,
    referralId = undefined,
    eventStatus = undefined,
    onClose,
}) => {
    const [deleteOnboardingStatus] = useDeleteOnboardingStatusMutation();

    return (
        <Dialog
            isOpen={isOpen}
            dialogTitle={Title}
            headerIcon={IconNames.WARNING_SIGN}
            onSecondaryButtonClick={() => {
                onClose();
            }}
            onPrimaryButtonClick={() => {
                try {
                    deleteOnboardingStatus({
                        eventId,
                        referralId,
                    }).unwrap();
                    SuccessToast({
                        message: 'Fill activity deleted successfully.',
                    });
                    onClose();
                } catch (error) {
                    handleError(
                        error,
                        'An error occurred deleting fill activity. Please try again.',
                    );
                }
            }}
            primaryButtonLabel="Yes, Delete Fill Activity"
            primaryButtonIntent={Button.Intent.DANGER}
            secondaryButtonLabel="Cancel"
            dialogContent={
                <>
                    <div className="padding__bottom--medium">
                        Are you sure you want to delete this Fill Activity?
                    </div>
                    <div className="sds_onboarding-activity__status-to-delete">{eventStatus}</div>
                </>
            }
        />
    );
};

DeleteFillActivityDialog.Title = Title;

DeleteFillActivityDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    eventId: PropTypes.string,
    referralId: PropTypes.string,
    eventStatus: PropTypes.string,
    onClose: PropTypes.func.isRequired,
};
